import { Phone } from 'lucide-react';
import { FilterStringConfig } from 'v5/patterns/filters/FilterWidget.types';

export function createPhonesFilterConfig(): FilterStringConfig {
  return {
    label: 'Phones',
    icon: <Phone className="size-4" />,
    type: 'string',
    createDefaultValue: () => ({ operator: 'contains', value: '' }),
    options: {
      placeholder: 'Search phones'
    }
  };
}
